import { notSelected } from "constants/constants";
import { IArgsFilters } from "./RCAAPComplianceEntityInterfaces";

/** Date field name used by compliance API (input_date for most, max_date for avg/methodology) */
export enum ComplianceArgsDateKey {
    INPUT_DATE = "input_date",
    MAX_DATE = "max_date",
}

/** Args object passed to RCA/AP compliance API queries */
export interface ComplianceArgs {
    input_date?: string;
    max_date?: string;
    meeting_type_ids?: string;
    meeting_type_null?: boolean;
}

/**
 * Builds the args object for RCA/AP compliance queries.
 * Used by GetRCAComplianceByMill, GetRCAComplianceByResponsible, GetActionPlanComplianceByMill,
 * GetAPComplianceByResponsible, GetAPAvgPerUser, and GetRcaMethodologyUsedByUser.
 */
export function buildComplianceArgs(filters: IArgsFilters, dateKey: ComplianceArgsDateKey): ComplianceArgs {
    const dateValue = filters.date;
    const base: ComplianceArgs = { [dateKey]: dateValue };

    return {
        ...base,
        ...(filters?.meetingTypeIds &&
            !filters.meetingTypeIds.includes(notSelected) &&
            filters.totalMeetingTypes &&
            filters.meetingTypeIds.length !== filters.totalMeetingTypes && {
                meeting_type_ids: `{${filters.meetingTypeIds}}`,
            }),
        ...(filters?.meetingTypeIds &&
            filters.meetingTypeIds.includes(notSelected) && {
                meeting_type_null: true,
            }),
    };
}
